module.exports = __webpack_public_path__ + "img/img59.f5896d95.svg";